<template>
  <issue-risk-score class="issue-risk-score" :issue="item"/>
</template>

<script>
import IssueRiskScore from '@/components/issue/IssueRiskScore.vue';

export default {
  name: 'IssueRiskScoreTableCell',
  components: {
    IssueRiskScore,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
